import { Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl,
} from '@angular/platform-browser';
import * as moment from 'moment';

/**
 * Sanitize HTML
 */
@Pipe({
  name: 'dateFormat',
})
export class DateTimeFormatPipe implements PipeTransform {
  constructor() {}

  /**
   * Transform
   *
   * @param value: string
   * @param type: string
   */
  transform(value: string, type: string) {
    // console.log('dateFormat');
    switch (type) {
      case 'time':
        return moment(value).format('HH:mm');
      case 'date':
        return moment(value).format('DD/MM');
      case 'monthYear':
        return moment(value).format('MM/YYYY');
      case 'fullDate':
        return moment(value).format('DD/MM/YYYY');
      case 'dateTime':
        return moment(value).format('HH:mm DD/MM');
      case 'dateTimeFull':
        return moment(value).format('HH:mm DD/MM/YYYY');
      case 'timeOrDate': {
        let result = moment(value).format('HH:mm');
        if (moment().isSame(moment(value), 'days')) return result;
        else if (moment().diff(moment(value), 'days') < 1) result += ' hôm qua';
        else result = moment(value).format('DD/MM');
        return result;
      }
      default:
        return moment(value).format();
    }
  }
}
